import React, {forwardRef, useContext, useEffect, useImperativeHandle, useReducer, useState} from 'react';
import {useAodSearch} from "../AodUi/aodHooks";
import {Button, Drawer, Space, Spin, Tabs} from "antd";
import {SalesSheetCard} from "../uiUtils/ItemCard";
//import TagGroup from "../uiUtils/TagGroup";
import AodBreadcrumb from "../AodUi/AodBreadcrumb";
import AodSelector from "../AodUi/AodSelector";
import {find, merge, remove} from "lodash";
import {BarSelect, RefreshButton} from "../uiUtils/Bar";
import {AppController} from "../App";
import {SalesSheetView} from "./SalsesSheetView";
import {ClientBridge} from "../index";
import {SalesSheetAction} from "../share/SpecAdAction";
import {getShareMenu, Pager} from "../uiUtils/Helpers";
import {useModel} from "../model/modelHooks";
import {Spread} from "../uiUtils/Spread";
import {calcFirstRow} from "../Wizard/utils";
import {FormOutlined, UndoOutlined} from "@ant-design/icons";
import {shallowReducer} from "../lib/Utils";


function SalesSheetSearch(
    {
        goToWizard,
        returnToWizard,
        ...props
    }, ref)
{

    const controller = useContext(AppController);
    const {model} = useContext(ClientBridge);

    const [crumbs, setCrumbs] = useState([]);
    const [drawer, setDrawer] = useState(false);
    const [shareAction, setShareAction] = useState();
    const [shareSheet, setShareSheet] = useState();
    const [shareAdvertiser, setShareAdvertiser] = useState();

    const account = useModel(model, 'account', 'selected_account', {one: true});
    const [advertiser, setAdvertiser] = useState();
    const [salesRep, setSalesRep] = useState();
    const [salesSheet, setSalesSheet] = useState();

    const advertiserList = useModel(model, 'advertiser', 'selected_account');
    const loginPerson = useModel(model, 'person', 'selected_login', {one: true});

    const [sort, setSort] = useState('Recently used');
    const [params, setParams] = useState({});
    model.salesSheet.getSetInfo('SalesSheetSearch');  //creates if doesn't exsist
    const {data:{records, total} = {}, error, isPending:loading, reload, setData} =
        useAodSearch(params,'salesSheet','SalesSheetSearch');

    const sortList = {
        'Recently used': {},
        'Newest': {sortField: 'createdDate'},
        'Oldest': {sortField: 'createdDate', ascending: true},
        'Name': {sortField: 'name', ascending: true}
    };
    const [pageSize, setPageSize] = useState(20);
    const [currentPage , setCurrentPage] = useState(1);
    const [searchProfile, setSearchProfile] = useReducer(shallowReducer,{});

    const [mode, setMode] = useState()
    /*
    // this is hiary than I thought mothballing for now

    // todo values array is inverted compared to templates - this is needed as value is dynamic
    //  - prefer this way if possible so values don't have to strings - ?use a Map
    //  - support dynamic values list (pull from DB)
    //  - sets (IN) not supported yet
    const filters = {
        owner: {
            label: 'Owner',
            type: 'radio',
            color: 'gold',
            filterField: 'salesRepId',  //'id',  // column
            //filterObj: 'salesRep',   // defaults to sarch ObjType
            //comparisonType: 'EQUALS',  // defaults to EQUALS
            values: {
                'All' : null,
                'Mine' : loginPerson.id
            }
        },
        name: {  //todo ? do as typeahead/autoComplete - would need list of all names - could be too many
            label: 'Name',
            type: 'input',  //?like
            color: 'green',
            filterField: 'name',  //'id',  // column
            //filterObj: 'salesRep',   // defaults to sarch ObjType
            comparisonType: 'LIKE',  // defaults to EQUALS
            values: {}
        }
    };
    const activeFilters = ['owner'];
    */

    useImperativeHandle(ref, () => ({
        reset: args => {
            reset(args);
        },
        refresh
    }));

    useEffect(()=>{
        setCurrentPage(1);
        setSearchProfile({advertiser, salesRep, account, sort});
    },[advertiser, salesRep, account, sort]);

    useEffect(()=>{
        const {advertiser, salesRep, account, sort} = searchProfile;
        if (account) {

            console.log('Building query page: ' + currentPage);
            const params = {
                ...sortList[sort],
                pageSize,
                firstRow: calcFirstRow({pageSize, currentPage})
            };

            if (advertiser) {
                merge(params, {searchBy: 'advertiser', id: advertiser.id});
            } else {
                merge(params, {searchBy: 'account', id: account.id});
            }

            if (salesRep) {
                merge(params, {
                    filterObj: 'salesRep',
                    filterField: 'id',
                    fieldValue: salesRep.id
                });
            }

            setParams(params);  //todo ?useReducer
        }
    },[searchProfile, pageSize, currentPage]);

    useEffect(()=>{
        const breadCrumbs = [];

        if (account) {
            breadCrumbs.push({
                type:'account',
                name:account.name,
                onClick: advertiser && (
                    ()=> {
                        setAdvertiser();
                        setSalesSheet();
                    }
                )
            });

            if (advertiser) {
                breadCrumbs.push({
                    type: 'advertiser',
                    name:(advertiser.name),
                    onClick: salesSheet && (()=>setSalesSheet())
                });
            }

            if (salesSheet){
                breadCrumbs.push({type:'salesSheet', name:salesSheet.name});
            }
        }

        setCrumbs(breadCrumbs);
    },[account, advertiser, salesSheet]);

    //todo - tad ugly ?Should visible salesSheet be in the model so it triggers - yes but may need cloning
    useEffect(()=>{
        if (salesSheet) {
            const latestSalesSheet = find(records, {id: salesSheet.id});
            if (latestSalesSheet && salesSheet.recordVersion !== latestSalesSheet.recordVersion) {
                setSalesSheet( salesSheet.recordVersion > latestSalesSheet.recordVersion
                    ? salesSheet : latestSalesSheet
                );
            }
        } else {
            setMode()
        }
    },[records,salesSheet]);

    function refresh(){
        controller.loadAdvertisers();
        reload();
    }

    function reset({advertiser, salesSheet}={}){
        setAdvertiser(advertiser);
        setSalesSheet(salesSheet);
    }

    function shareSalesSheet(salesSheet,action){
        setShareSheet(salesSheet);
        setShareAdvertiser(model.advertiser.get(salesSheet.advertiserId));
        setShareAction(action);
    }

    function salesSheetView(newSalesSheet,{mode}={}){
        const newAdvertiser = find(advertiserList,{id:newSalesSheet.advertiserId});
        if (newAdvertiser) { // always should be...
            setAdvertiser(newAdvertiser)
        }
        setSalesSheet(newSalesSheet);
        setMode(mode)
    }

    async function  onDelete(salesSheet){
        remove(records, {id: salesSheet.id});
        setData({records, total: total-1});
        setSalesSheet();
        await controller.deleteSalesSheet(salesSheet);
        reload();
    }

    function getSalesRepTags(){
        return salesRep
            ? salesRep.id===loginPerson.id
                ? ['My presentations']
                : [salesRep.displayName]
            : [];
    }

    function resetSearch(){
        setAdvertiser();
        setSalesRep();
        setSalesSheet(); // probably not needed
        setSort('Recently used');
    }

    function onPageSizeChange(current, newPageSize){
        console.log("Current?: "+current);
        setPageSize(newPageSize);
    }

    // <Button onClick={returnToWizard}
    return <div>
        <Drawer
            title="Filters"
            placement="right"
            closable={true}
            onClose={()=>setDrawer(false)}
            visible={drawer}
            className='drawer-form'
            zIndex={1010}
            width={400}
            bodyStyle={{backgroundColor:'whitesmoke'}}
        >
            <h4>Advertiser</h4>
            <AodSelector itemType={'advertiser'} setName={'selected_account'}
                         onSelect={setAdvertiser} value={advertiser}
                         none={'All'}
            />
            <div style={{height:20}}/>
            <h4>Sales Rep</h4>
            <AodSelector itemType={'person'} setName={'account_person'}
                         onSelect={setSalesRep} value={salesRep}
                         label={'displayName'}
                         none={'All'} top={loginPerson}
            />
        </Drawer>

        <Space>
            <Button onClick={()=>goToWizard({advertiser, salesSheet})}
                    style={{width:190,marginLeft:5}}
                    type={'primary'}
                    icon={<FormOutlined/>}
            >Return to Wizard</Button>
            <AodBreadcrumb crumbs={crumbs} style={{marginTop:0, marginRight:10}}/>
        </Space>

        <Tabs tabBarStyle={{display:'none'}} activeKey={salesSheet?'salesSheet':'search'}>

            <Tabs.TabPane tab='Search Presentations' key={'search'}>
                <Spin spinning={loading} delay={500} size="large">

                    <div>
                        {records && <>
                            <Spread style={{background: '#EEE', borderRadius:5, marginBottom:0}}
                                leftCol={18}
                                left={<Space>
                                    <RefreshButton onRefresh={refresh} primary={error} title={'refresh search'}/>
                                    <span>
                                        Sort by:
                                        <BarSelect list={sortList} value={sort} onChange={setSort} />
                                    </span>
                                    <span>Advertiser:
                                        <AodSelector itemType={'advertiser'} setName={'selected_account'}
                                                     onSelect={setAdvertiser} value={advertiser}
                                                     none={'All'} size='small'
                                                     width={240}
                                        />
                                    </span>
                                    <span>Sales Rep:
                                        <AodSelector itemType={'person'} setName={'account_person'}
                                                     onSelect={setSalesRep} value={salesRep}
                                                     label={'displayName'} size='small'
                                                     none={'All'} top={loginPerson}
                                                     width={240}
                                        />
                                    </span>
                                    <Button size={'small'} onClick={resetSearch} >
                                        <UndoOutlined rotate={90}/>reset</Button>
                                </Space>}
                                right={
                                    <Pager total={total}
                                           pageSize={pageSize} onShowSizeChange={onPageSizeChange}
                                           current={currentPage} onChange={setCurrentPage}
                                    />}
                            />

                            {records.map(ss => <SalesSheetCard
                                asset={ss}
                                onAppend={() => goToWizard({salesSheet:ss})}
                                onOpen={() => salesSheetView(ss)}
                                onPresent={() => salesSheetView(ss,{mode:'present'})}
                                onDelete={()=>onDelete(ss)}
                                shareMenu={getShareMenu({item:ss, onAction:shareSalesSheet})}
                                key={ss.id}
                            />)}

                            <Spread
                                style={{background: '#eee', marginTop:10, borderRadius:5}}
                                left={<div style={{margin:5}}>Total: {total}</div>}
                                right={
                                    <Pager total={total}
                                           pageSize={pageSize} onShowSizeChange={onPageSizeChange}
                                           current={currentPage} onChange={setCurrentPage}
                                    />}
                            />
                        </>}

                        {error && <span>Search failed</span>}
                    </div>
                </Spin>
            </Tabs.TabPane>

            <Tabs.TabPane tab={'Display Spec Ads'} key={'salesSheet'}>
            {salesSheet
                ? <SalesSheetView onAppend={() => goToWizard({salesSheet})}
                                  onDelete={()=>onDelete(salesSheet)}
                                  salesSheet={salesSheet}
                                  setSalesSheet={setSalesSheet}
                                  advertiser={advertiser}
                                  goToWizard={goToWizard}
                                  shareSalesSheet={shareSalesSheet}
                                  refresh={refresh}
                                  mode={mode}
                />
                : <span>No Presentation selected</span>
            }
            </Tabs.TabPane>

        </Tabs>

        <SalesSheetAction advertiser={shareAdvertiser} salesSheet={shareSheet}
                      action={shareAction} onActionDone={()=>setShareAction('')}
        />
    </div>
}
export default SalesSheetSearch = forwardRef(SalesSheetSearch);

/*
<AdvertiserAutoComplete model={model} allowClear={true}
                                    value={advertiser}
                                    onSelect={setAdvertiser}
            />


{!salesSheet && records && <>
                <TagGroup tags={getSalesRepTags()}
                          onRemoveTag={()=>setSalesRep()}
                          color='gold'
                          icon={<AodIcon type={'salesRep'}/>}
                />
            </>}
                <TagGroup onNewTag={()=>setDrawer(true)}
                          newLabel='New Filter'
                          disabled={!!salesSheet}/>
 */